module.exports = __webpack_public_path__ + "img/deductible_indemnities.9d600016.svg";